import React from "react";

export interface ProfileFields {
  fullName: string;
  displayName: string;
  hometown: string;
  school: string;
  work: string;
  interests: string;
  bio: string;
  preferredSaunaTempF: string;
}

interface Props {
  fields: ProfileFields;
  onChange: (fields: ProfileFields) => void;
}

export default function ProfileForm({ fields, onChange }: Props) {
  const set =
    (key: keyof ProfileFields) =>
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
      onChange({ ...fields, [key]: e.target.value });

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      <Field label="Full name">
        <input
          type="text"
          value={fields.fullName}
          onChange={set("fullName")}
          placeholder="e.g. Jane Smith"
          style={inputStyle}
        />
      </Field>
      <Field label="Display name (optional)">
        <input
          type="text"
          value={fields.displayName}
          onChange={set("displayName")}
          placeholder="e.g. Jane S."
          style={inputStyle}
        />
        <span style={{ fontSize: 12, color: "#9ca3af" }}>
          Shown to hosts/guests instead of your full name, e.g. on bookings.
        </span>
      </Field>
      <Field label="Hometown">
        <input
          type="text"
          value={fields.hometown}
          onChange={set("hometown")}
          placeholder="e.g. Minneapolis, MN"
          style={inputStyle}
        />
      </Field>
      <Field label="Where I went to school">
        <input
          type="text"
          value={fields.school}
          onChange={set("school")}
          placeholder="e.g. University of Minnesota"
          style={inputStyle}
        />
      </Field>
      <Field label="My work">
        <input
          type="text"
          value={fields.work}
          onChange={set("work")}
          placeholder="e.g. Truck Driver"
          style={inputStyle}
        />
      </Field>
      <Field label="My interests">
        <input
          type="text"
          value={fields.interests}
          onChange={set("interests")}
          placeholder="e.g. outdoors, reading, cold plunges"
          style={inputStyle}
        />
      </Field>
      <Field label="About me">
        <textarea
          value={fields.bio}
          onChange={set("bio")}
          placeholder="Tell hosts a little more about yourself..."
          rows={4}
          style={{ ...inputStyle, resize: "vertical" }}
        />
      </Field>
      <Field label="Preferred sauna temperature (°F)">
        <input
          type="number"
          value={fields.preferredSaunaTempF}
          onChange={set("preferredSaunaTempF")}
          placeholder="e.g. 185"
          min={100}
          max={250}
          style={{ ...inputStyle, width: 120 }}
        />
        <span style={{ fontSize: 12, color: "#9ca3af", marginLeft: 8 }}>
          100–250 °F
        </span>
      </Field>
    </div>
  );
}

function Field({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) {
  return (
    <div>
      <label
        style={{
          display: "block",
          fontSize: 13,
          fontWeight: 600,
          marginBottom: 4,
          color: "#374151",
        }}
      >
        {label}
      </label>
      {children}
    </div>
  );
}

const inputStyle: React.CSSProperties = {
  width: "100%",
  padding: "9px 12px",
  border: "1px solid #d1d5db",
  borderRadius: 6,
  fontSize: 14,
  boxSizing: "border-box",
};
